<app-error-screen-layout [logoAlt]="copy.logoAlt">
  <h1>{{ copy.heading }}</h1>
  <p>{{ copy.body }}</p>
  <button type="button" class="home-link" (click)="recover('go-home')">{{ copy.homeLink }}</button>
</app-error-screen-layout>